import { render } from "./AllCards.vue?vue&type=template&id=1969fcbe&scoped=true"
import script from "./AllCards.vue?vue&type=script&lang=js"
export * from "./AllCards.vue?vue&type=script&lang=js"

import "./AllCards.vue?vue&type=style&index=0&id=1969fcbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1969fcbe"]])

export default __exports__